import * as types from '../actions/action-types';

const getInitialState = () => ({
  usingExpressCheckout: false,
  clientIdList: [],
  expressIndex: -1,
});

const expressCheckoutReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.SET_USING_EXPRESS_CHECKOUT:
      return {
        ...state,
        usingExpressCheckout: action.isUsingExpressCheckout,
        expressIndex: action.index,
      };
    
    case types.UPDATE_CLIENT_ID_LIST:
      return {
        ...state,
        clientIdList: state.clientIdList.some(option => option[action.clientIdByPayment.name] !== undefined)
          ? state.clientIdList
          : [...state.clientIdList, {[action.clientIdByPayment.name]: action.clientIdByPayment.clientId}],
      };
    default:
      return state;
  }
};

export default expressCheckoutReducer;
